import {handleActions} from 'redux-actions'
import * as ActionTypes from './actionTypes'

const initialState = {
    baseAccountInformationEditable: false,
    accessToActiTimeEditable: false,
    accessToActiPlansEditable: false,
    departmentEditable: false,
    timeZoneEditable: false,
    hireAndReleaseDatesEditable: false,
    approvalSettingsEditable: false,
    workScheduleEditable: false,
    overtimeSettingsEditable: false,
    costOfWorkRatesEditable: false,

    permissionsEditable: false,
    teamScopeEditable: false,
    manageScopeEditable: false,

    hasRightsToDeleteUser: false,
}

export default handleActions({
    [ActionTypes.FIELDS_EDITABILITY_SET]: (state, {payload: changedFields}) => ({
        ...state,
        ...changedFields,
    }),
    [ActionTypes.CAN_EDIT_ENTIRE_USER_SET]: (state) => ({
        ...state,
        baseAccountInformationEditable: true,
        accessToActiTimeEditable: true,
        accessToActiPlansEditable: true,
        departmentEditable: true,
        timeZoneEditable: true,
        hireAndReleaseDatesEditable: true,
        approvalSettingsEditable: true,
        workScheduleEditable: true,
        overtimeSettingsEditable: true,
        costOfWorkRatesEditable: true,

        permissionsEditable: true,
        teamScopeEditable: true,
        manageScopeEditable: true,

        hasRightsToDeleteUser: true,
    })
}, initialState)


// WEBPACK FOOTER //
// ./web/js/panels/user/authorizationInfo/reducer.js